enum RouteEnum {
    HOME = `/`,
    ACCESSO = `/login`,
    DASHBOARD = `/dashboard`,
    ACCESSIBILITA = `/accessibilita`,
    COOKIES = `/cookies`,
    NOTE_LEGALI = `/note-legali`,
    PRIVACY_POLICY = `/privacy-policy`,
    NUOVO_APPUNTAMENTO = `/nuovo-appuntamento`,
    CQS = `/cqs`,
    CQP = `/cqp`,
    DLG = `/dlg`,
    SIMULAZIONI = `/simulazioni`,
    PREVENTIVI = `/preventivi`,
    NOTIFICHE = `/notifiche`,
    NOTE = `/note`,
    SEARCH_SIMULAZIONE = `/search/simulazione`,
    SEARCH_PREVENTIVO = `/search/preventivo`,
    RISULTATI = `/risultati`,
    RISULTATI_SIMULAZIONE = `/risultati/simulazione`,
    RISULTATI_PREVENTIVI = `/risultati/preventivi`,
    CQ_CRM = `/cq-crm`,
}

export default RouteEnum;
